
import { atom } from "jotai";

export type LatLng = { lat: number; lng: number } | null;

export const llAtom = atom<LatLng>(null);
